import { get } from 'lodash';

const styles = ({ padding, color }) => ({
  outerContainer: {
    color: get(color, 'bodyText'),
    padding: '3rem',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "flex-start",
  },
  contentContainer: {
    width: '35%',
    backgroundColor: get(color, 'white'),
    border: `1px solid ${color.grayBorder}`,
    paddingTop: get(padding, 'p36'),
    padding: "48px",
    display: 'flex',
    flexDirection: 'column',
    "& form": {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      height: '100px',
    },
  },
  headerText: {
    marginTop: "12px",
    marginBottom: 0,
    textAlign: 'center',
  },
  alternateLogo: {
    marginBottom: 0,
  },
  fieldContainer: {
    marginTop: "24px !important",
    marginBottom: "24px !important",
  },
  textField: {
    paddingTop: '2px !important',
    paddingBottom: '0px !important',
  },
  submitButton: {
    '&:focus': {
      border: `1px solid #FFFFFF`,
      outline: `1px solid ${get(color, 'primaryButtonBackground')}`,
    },
  },
  notification: {
    top: 14,
  },
});
export default styles;